<template>
  <div class="main">
    <!-- 模型展示界面 -->
    <img id="logo" class="logo" :src="upload.mod.logoName ? './model/show/tempFile/'+upload.mod.modelId+'/logo/'+ upload.mod.logoName : ''" />
    <div id="container" class="container"></div>
    <a-progress class="progress" type="dashboard" v-show="this.modelView.showProgress" :percent="this.modelView.progress"/>
    <div class="uploader">
      <a-form-model ref="uploadForm" :model="upload.mod" :rules="upload.rules">
        <a-form-model-item label="模型名称" prop="name">
          <a-input v-model="upload.mod.name" placeholder="请输入模型名称" />
        </a-form-model-item>
        <a-form-model-item label="模型说明">
          <a-input
            v-model="upload.mod.remark"
            type="textarea"
            :rows="4"
            placeholder="请输入模型说明"
          />
        </a-form-model-item>
        <a-form-model-item label="全景地址">
          <a-input
            v-model="upload.mod.vrAddr"
            type="textarea"
            placeholder="请输入全景地址"
          />
        </a-form-model-item>
        <a-form-model-item
          label="模型类型"
          style="display: flex; justify-content: start; margin: 0 auto"
        >
          <a-dropdown :trigger="['click']">
            <a
              class="ant-dropdown-link"
              @click="(e) => e.preventDefault()"
              id="dropdown"
              >{{ selectedType }}<a-icon type="down"
            /></a>
            <a-menu slot="overlay" @click="handleMenuClick">
              <a-menu-item v-for="t in modelType" :key="t.id">
                {{ t.type }}
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </a-form-model-item>
        <a-form-model-item
          label="公开浏览"
          style="display: flex; justify-content: start; margin: 0 auto"
        >
          <a-switch v-model="upload.mod.publictoother" />
        </a-form-model-item>
        <a-form-model-item
          label="启用浏览"
          style="display: flex; justify-content: start; margin: 0 auto"
        >
          <a-switch v-model="upload.mod.enableView" />
        </a-form-model-item>
        <!-- <a-form-model-item
          label="需要密码"
          style="display: flex; justify-content: start; margin: 0 auto"
        >
          <a-switch v-model="upload.mod.needPassword" />
        </a-form-model-item>
        <a-form-model-item label="密码" v-if="upload.mod.needPassword">
          <a-input
            v-model="upload.mod.password"
            type="textarea"
            placeholder="请输入密码"
          />
        </a-form-model-item> -->
        <a-form-model-item
          label="模型文件（支持obj、fbx）"
          prop="modelName"
          v-if="upload.status == 'add'"
        >
          <a-upload
            accept=".obj,.fbx"
            action="./uploadFile/upload"
            :data="{
              type: 'model',
              fileType:upload.mod.modelFileType,
              uuid:upload.mod.modelId
            }"
            :fileList="upload.modelFileList"
            @change="modelFileChange"
          >
            <a-button> <a-icon type="upload" />点击上传模型 </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item
          label="封面图片"
          prop="coverName"
          v-if="upload.status == 'add'&&upload.modelUploaded"
        >
          <a-upload
            listType="picture"
            accept=".jpg, .png"
            action="./uploadFile/upload"
            :data="{
              type: 'cover',
              fileType:upload.mod.modelFileType,
              uuid:upload.mod.modelId
            }"
            :fileList="upload.coverFileList"
            @change="coverFileChange"
          >
            <a-button> <a-icon type="upload" />点击上传封面图片 </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item
          label="logo"
          prop="logoName"
          v-if="upload.status == 'add'&&upload.modelUploaded"
        >
          <a-upload
            listType="picture"
            accept=".jpg, .png"
            action="./uploadFile/upload"
            :data="{
              type: 'logo',
              fileType:upload.mod.modelFileType,
              uuid:upload.mod.modelId
            }"
            :fileList="upload.logoFileList"
            @change="logoFileChange"
          >
            <a-button> <a-icon type="upload" />点击上传logo </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item
          label="帖图zip压缩包"
          prop="mapsName"
          v-if="upload.status == 'add'&&upload.modelUploaded"
        >
          <a-upload
            accept=".zip"
            action="./uploadFile/upload"
            :data="{
              type: 'maps',
              fileType:upload.mod.modelFileType,
              uuid:upload.mod.modelId
            }"
            :fileList="upload.mapsFileList"
            @change="mapsFileChange"
          >
            <a-button> <a-icon type="upload" />点击上传贴图 </a-button>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
      <div class="submit">
        <a-button type="primary" @click="viewModel" style="margin-right: 8px">预览</a-button>
        <a-button type="primary" @click="uploadSave" style="margin-right: 8px">保存</a-button>
      </div>
    </div>
    <div class="setEvironment">
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="开启主灯">
          <a-switch default-checked @change="onToogleMainLight" />
        </a-form-item>
        <a-form-item label="亮度" v-show="enableMainLight">
           <a-slider v-model="mainLightIntensity" :min="0" :max="5" :step="0.01" @change="mainLightChange"/>
        </a-form-item>
        <a-form-item label="开启环境灯">
          <a-switch default-checked @change="onToogleEvironmentLight" />
        </a-form-item>
        <a-form-item label="亮度" v-show="enableEnvironmentLight">
           <a-slider v-model="environmentLightIntensity" :min="0" :max="5" :step="0.01" @change="environmentLightChange"/>
        </a-form-item>
        <a-form-item label="摄像机位置" v-show="enableEnvironmentLight">
           <a-form layout="inline">
             <a-form-item label="x">
               <a-input-number v-model="camera_x" @change="camera_x_change"/>
             </a-form-item>
             <a-form-item label="y">
               <a-input-number v-model="camera_y" @change="camera_y_change"/>
             </a-form-item>
             <a-form-item label="z">
               <a-input-number v-model="camera_z" @change="camera_z_change"/>
             </a-form-item>
           </a-form>
        </a-form-item>
        <a-form-item label="背景色">
           <sketch-picker class="colorpicker" v-model="color" @input="colorValueChange"></sketch-picker>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
import { Sketch } from "vue-color";
import { Server } from "../../../js/Server/Server";
import { SceneManager } from "../../../js/Scene/SceneManager";

export default {
  metaInfo: {
    meta: [{ charset: "utf-8" }],
  },
  components: {
    "sketch-picker": Sketch,
  },
  name: "Model",
  data() {
    return {
      formLayout: 'horizontal',
      user:{id:"",nicName:""},
      server: new Server(),
      sceneManager: null,
      view_placement: "topCenter",
      firstTimeOnlocal: "true",
      showIntrodution: true,
      modelType: [],
      //颜色板的颜色
      color: "",
      //分享相关变量
      isshowcolorpicker: false,
      modelView: {
        title: "",
        showProgress: false,
        progress: 0,
        logoShow: true,
      },
      clock: new THREE.Clock(),
      meta: [],
      loadedObj: null,
      selectedType: "请选择类型",
      upload: {
        show: false,
        title: "上传模型",
        status: "add",
        modelUploaded:false,
        coverFileList: [],
        logoFileList: [],
        modelFileList: [],
        mapsFileList: [],
        mod: {
          id: "",
          name: "",
          remark: "",
          uploadTime: "",
          path: "",
          coverName: "",
          logoName: "",
          modelName: "",
          modelId: "",
          mapsName: "",
          backgroundColor: "rgb(222,222,222)",
          vrAddr: "",
          enableView: true,
          needPassword: false,
          password: "",
          modelType: "",
          userID: "",
          modelFileType:"",
          modelPath:"",
          initInfo:"",
          publictoother:false
        },
        rules: {
          name: [
            { required: true, message: "模型名称不能为空", trigger: "blur" },
          ],
          coverName: [
            { required: true, message: "请上传封面图片", trigger: "change" },
          ],
          modelName: [
            { required: true, message: "请上传模型文件", trigger: "change" },
          ],
          modelType: [
            { required: true, message: "请选择模型类型", trigger: "change" },
          ],
        },
      },
      enableMainLight:true,
      mainLightIntensity:1,
      enableEnvironmentLight:true,
      environmentLightIntensity:0.5,
      camera_x:30,
      camera_y:30,
      camera_z:30,
      initInfo:{}
    };
  },
  mounted() {
    this.initScene();
    this.server.getModelType(this.getModelTypeCallBack);
    this.user.id=localStorage.getItem("userID");
    this.user.nicName=localStorage.getItem("nicName");
    window.onresize = () => {
      this.onWindowResize();
    };
    document.title="上传模型";
  },
  methods: {
    getModelTypeCallBack(modelType){
      this.modelType=modelType;
    },
    handleCancel() {
      this.ShowPasswordInput = false;
    },
    getModel(id) {},

    //选择颜色
    changcolorclick() {
      this.isshowcolorpicker = !this.isshowcolorpicker;
    },
    //模型信息
    colorValueChange(val) {
      var bgColor = colorRgb(val.hex);
      this.model.backgroundColor = bgColor;
      this.sceneManager.setBackGroundColor(this.model.backgroundColor);
    },
    changeColor() {
      this.isshowcolorpicker = false;
      this.server.updateColor(this.model);
    },
    viewReturnOrigin() {
      this.sceneManager.viewReturnOrigin();
    },
    initScene() {
      this.sceneManager = new SceneManager();
      let container = document.getElementById("container");
      container.childNodes.forEach((childNode) => {
        container.removeChild(childNode);
      });
      let doElement = this.sceneManager.initScene(this.upload.mod.backgroundColor);
      container.appendChild(doElement[0]);
      this.animate();
    },

    onWindowResize() {
      this.sceneManager.onWindowResize();
    },
    animate() {
      requestAnimationFrame(this.animate);
      const delta = this.clock.getDelta();
      if (this.mixer) this.mixer.update(delta);

      this.sceneManager.animate();
    },
    progress(xhr) {
      if (xhr.loaded == xhr.total) {
        this.modelView.showProgress = false;
      } else {
        this.modelView.progress = Math.ceil(
          ((xhr.loaded / xhr.total) * 100).toFixed(2)
        );
      }
    },
    //上传时选报模型类型
    handleMenuClick(e) {
      this.selectedType = this.modelType[e.key].type;
      this.upload.mod.modelType = this.selectedType;
    },
    //上传封面文件
    coverFileChange(info) {
      if (info.file) {
        if (info.file.status == "done") {
          console.log("上传封面成功："+info.file.name);
          this.upload.mod.coverName = info.file.name;
          info.fileList.length > 1 ? info.fileList.splice(0, 1) : "";
        } else if (info.file.status == "uploading") {
          console.log("上传封面文件失败");
          this.upload.mod.coverName = info.file.name;
          info.fileList.length > 1 ? info.fileList.splice(0, 1) : "";
          this.upload.coverFileList = info.fileList;
        }
      }
    },
    //上传logo文件
    logoFileChange(info) {
      if (info.file) {
        if (info.file.status == "done") {
          console.log("logo文件上传完成");
          this.upload.mod.logoName = info.file.name;
          console.log("logo文件名"+info.file.name);
          info.fileList.length > 1 ? info.fileList.splice(0, 1) : "";
        } else if (info.file.status == "uploading") {
          console.log("logo上传错误");
          this.upload.mod.logoName = info.file.name;
          info.fileList.length > 1 ? info.fileList.splice(0, 1) : "";
          this.upload.logoFileList = info.fileList;
        }
      }
    },
    //上传模型文件
    modelFileChange(info) {
      if (info.file) {
        if (info.file.status == "done") {
          console.log("上传模型文件名："+info.file.response);
          this.upload.modelUploaded=true;
          this.upload.mod.modelId = info.file.response;
          console.log
          this.upload.mod.modelName = info.file.name;
          this.upload.mod.modelFileType=this.upload.mod.modelName.substring(this.upload.mod.modelName.lastIndexOf('.')+1);
          info.fileList.length > 1 ? info.fileList.splice(0, 1) : "";
        } else if (info.file.status == "uploading") {
          this.upload.modelUploaded=false;
          this.upload.mod.modelName = info.file.name;
          this.upload.modelFileList = info.fileList;
        }
      }
    },
    //上传贴图文件
    mapsFileChange(info) {
      if (info.file) {
        if (info.file.status == "done") {
          this.upload.mod.mapsName = info.file.name;
          info.fileList.length > 1 ? info.fileList.splice(0, 1) : "";
        } else if (info.file.status == "uploading") {
          this.upload.mod.mapsName = info.file.name;
          info.fileList.length > 1 ? info.fileList.splice(0, 1) : "";
          this.upload.mapsFileList = info.fileList;
        }
      }
    },
    viewModel(){
      this.modelView.showProgress=true;
      let modelPath="./model/show/tempFile/"+this.upload.mod.modelId+"/"+this.upload.mod.modelName;
      let mapsPath="";
      if(this.upload.mod.mapsName!==""&&this.upload.mod.mapsName!==null){
        mapsPath="./model/show/tempFile/"+this.upload.mod.modelId+"/maps/";
      }
      this.sceneManager.loadModel(modelPath,mapsPath,this.upload.mod.modelFileType,this.progress);
      this.sceneManager.setMainLight(this.mainLightIntensity);
      this.sceneManager.setHelpLight(this.environmentLightIntensity);
    },
    //上传模型
    uploadSave() {
      this.upload.mod.remark = this.upload.mod.remark.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>");
      this.upload.mod.userID = this.user.id;
      if (this.upload.status == "add") {
        this.$refs.uploadForm.validate((valid) => {
          if (valid) {
            this.initInfo["enableMainLight"]=this.enableMainLight;
            this.initInfo["mainLightIntensity"]=this.mainLightIntensity;
            this.initInfo["enableEnvironmentLight"]=this.enableEnvironmentLight;
            this.initInfo["environmentLightIntensity"]=this.environmentLightIntensity;
            this.initInfo["camera_x_position"]=this.camera_x;
            this.initInfo["camera_y_position"]=this.camera_y;
            this.initInfo["camera_z_position"]=this.camera_z;
            this.upload.mod.initInfo=JSON.stringify(this.initInfo);
            this.axios.post("./model/insert", this.upload.mod).then((res) => {
              if (res.data != "error") {
                this.$message.success("已成功保存模型");
                this.upload.show = false;
                this.goToModelView(this.upload.mod.modelId);
                this.resetScene();
              } else {
                this.$message.error("模型保存失败，请重试或联系管理员！");
              }
            });
          } else {
            return false;
          }
        });
      } else if (this.upload.status == "update") {
        this.$refs.uploadForm.validate((valid) => {
          if (valid) {
            this.axios.post("./model/update", this.upload.mod).then((res) => {
              if (res.data != "error") {
                this.$message.success("已成功修改模型");
                this.upload.show = false;
              } else {
                this.$message.error("模型修改失败，请重试或联系管理员！");
              }
            });
          } else {
            return false;
          }
        });
      }
    },

    //重置场景
    resetScene(){
      this.upload.status = "add";
      this.upload.title = "上传模型";
      this.upload.coverFileList = [];
      this.upload.logoFileList = [];
      this.upload.modelFileList = [];
      this.upload.mapsFileList = [];
      this.selectedType = "请选择类型";
      this.upload.modelUploaded=false;
      this.upload.mod = {
        id: "",
          name: "",
          remark: "",
          uploadTime: "",
          path: "",
          coverName: "",
          logoName: "",
          modelName: "",
          modelId: "",
          mapsName: "",
          backgroundColor: "rgb(222,222,222)",
          vrAddr: "",
          enableView: true,
          needPassword: false,
          password: "",
          modelType: "",
          userID: "",
          modelFileType:"",
          modelPath:"",
          initInfo:""
      };
      if(this.sceneManager){
        this.sceneManager.removeAddedModel();
      }
    },

    //跳转到模型展示页面
    goToModelView(modelID) {
      let routeData=this.$router.resolve({ 
        name: "Model",
        params: { id: modelID },
        query: { id:modelID },
        });
        window.open(routeData.href,'_blank');
    },
    //#region 调整场景
    onToogleMainLight(checked){
      this.enableMainLight=checked;
      if(this.sceneManager){
        if(checked){
          this.sceneManager.setMainLight(this.mainLightIntensity);
        }else{
          this.sceneManager.removeMainLight();
        }
      }
    },
    onToogleEvironmentLight(checked){
      this.enableEnvironmentLight=checked;
      if(this.sceneManager){
        if(checked){
          this.sceneManager.setHelpLight(this.environmentLightIntensity);
        }else{
          this.sceneManager.removeHelpLight();
        }
      }
    },
    mainLightChange(value){
      if(this.sceneManager){
        this.sceneManager.setMainLightIntensity(value);
      }
    },
    environmentLightChange(value){
      if(this.sceneManager){
        this.sceneManager.setEnvironmentLightIntensity(value);
      }
    },
    camera_x_change(value){
      if(this.sceneManager){
        this.sceneManager.setCameraXPosition(value);
      }
    },
    camera_y_change(value){
      if(this.sceneManager){
        this.sceneManager.setCameraYPosition(value);
      }
    },
    camera_z_change(value){
      if(this.sceneManager){
        this.sceneManager.setCameraZPosition(value);
      }
    },
    colorValueChange(value){
      var bgColor = colorRgb(value.hex);
      this.upload.mod.backgroundColor = bgColor;
      this.sceneManager.setBackGroundColor(this.upload.mod.backgroundColor);
    },
    //#endregion
  },
};
function colorRgb(rgb) {
  // 16进制颜色值的正则
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 把颜色值变成小写
  var color = rgb.toLowerCase();
  if (reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      var colorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }
    // 处理六位的颜色值，转为RGB
    var colorChange = [];
    for (var j = 1; j < 7; j += 2) {
      colorChange.push(parseInt("0x" + color.slice(j, j + 2)));
    }
    return "rgb(" + colorChange.join(",") + ")";
  } else {
    return color;
  }
}
</script>

<style scoped>
.main {
  display: flex;
}

.uploader {
  width: 480px;
  height: 100%;
  position: absolute;
  background: rgba(107, 107, 107, 0.2);
  padding: 20px;
  overflow: scroll;
}
.container {
  width: 100%;
  height: 100%;
}
.submit {
  display: flex;
  bottom: 20px;
  justify-content: space-around;
  width: 100%;
}
.logo {
  display: inline-block;
  height: 40px;
  width: auto;
  position: absolute;
  top: 30px;
  left: 30px;
}
.progress{
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -50px;
  margin-left: -50px;
}
.setEvironment{
  width: 480px;
  height: 100%;
  position:absolute;
  right: 0;
  background: rgba(107, 107, 107, 0.2);
  overflow: scroll;
}
</style>